import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [connectionStatus, setConnectionStatus] = useState({
    connected: null,
    responseTime: null,
    isChecking: false
  });

  // Check connection status
  const checkConnection = async () => {
    setConnectionStatus(prev => ({ ...prev, isChecking: true }));
    try {
      const response = await fetch('/api/caption/connection-status');
      if (response.ok) {
        const result = await response.json();
        const data = result.data || result;
        setConnectionStatus({
          connected: data.connected,
          responseTime: data.responseTime,
          isChecking: false
        });
      } else {
        setConnectionStatus({
          connected: false,
          responseTime: null,
          isChecking: false
        });
      }
    } catch (error) {
      setConnectionStatus({
        connected: false,
        responseTime: null,
        isChecking: false
      });
    }
  };

  // Check connection on mount and periodically
  useEffect(() => {
    checkConnection();
    const interval = setInterval(checkConnection, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <footer className="bg-surface border-t border-border">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex flex-col space-y-4">
          {/* Main footer content */}
          <div className="flex justify-between items-center">
            <div className="text-sm text-secondaryText">
              © 2024 LoRA Caption Generator
            </div>
            
            {/* Connection Status - Minimal and contemporary */}
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
              <div className={`w-2 h-2 rounded-full animate-pulse-slow ${
                connectionStatus.connected === null ? 'bg-secondaryText' :
                connectionStatus.connected ? 'bg-accent' : 'bg-red-500'
              }`} />
              <span className="text-sm text-secondaryText" style={{ minWidth: '120px', display: 'inline-block' }}>
                OpenAI
                {connectionStatus.responseTime !== null && connectionStatus.connected ? (
                  <span className="text-xs ml-1 text-secondaryText/70">
                    ({connectionStatus.responseTime}ms)
                  </span>
                ) : (
                  <span className="text-xs ml-1 text-secondaryText/70 invisible">
                    (000ms)
                  </span>
                )}
              </span>
              </div>
              
              {/* Subtle refresh button */}
              <button
              onClick={checkConnection}
              disabled={connectionStatus.isChecking}
              className={`p-1 rounded transition-all duration-200 ${
                connectionStatus.isChecking
                  ? 'text-secondaryText/50 cursor-not-allowed'
                  : 'text-secondaryText hover:text-primaryText hover:bg-button'
              }`}
              title="Refresh connection status"
            >
              <svg 
                className={`w-4 h-4 ${connectionStatus.isChecking ? 'animate-spin' : ''}`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
                />
              </svg>
              </button>
            </div>
          </div>
        </div>
        
        {/* Legal links */}
        <div className="border-t border-border pt-3 flex justify-center space-x-6" style={{ minHeight: '32px' }}>
          <Link to="/privacy" className="text-xs text-secondaryText hover:text-primaryText transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="text-xs text-secondaryText hover:text-primaryText transition-colors">
            Terms of Service
          </Link>
          <Link to="/cookies" className="text-xs text-secondaryText hover:text-primaryText transition-colors">
            Cookie Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;